const comments = [
  {
    name: '影视发烧友阿强',
    text: '用了小辣椒影院快两年了，资源更新真的很快，画质也很清晰。最关键是免费！不用注册不用付费，打开就能看，太方便了。强烈推荐给所有喜欢看电影的朋友！',
    time: '3 天前',
    avatar: 'ri-user-3-line',
  },
  {
    name: '追剧达人小美',
    text: '最近在追的几部剧这里都有，而且更新和电视台同步，不用等。画质选 1080P 非常清楚，加载速度也快。已经推荐给身边好几个朋友了，都成了小辣椒的忠实用户哈哈。',
    time: '1 周前',
    avatar: 'ri-user-3-line',
  },
  {
    name: '周末电影控老张',
    text: '作为每周必看一部电影的人，小辣椒影院简直就是宝藏。分类很全，从好莱坞大片到小众文艺片都有。播放流畅不卡顿，周末窝在沙发上看电影的感觉太棒了。',
    time: '2 周前',
    avatar: 'ri-user-3-line',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">观众热评</h2>
        <p className="text-sm text-foreground-600 text-center mb-10 md:mb-12">听听影迷们怎么说小辣椒影院</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div key={comment.name} className="bg-background-50 border border-background-200/70 rounded-lg p-5 md:p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                  <i className={`${comment.avatar} text-accent-600 text-lg`}></i>
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-foreground-900 text-sm whitespace-nowrap">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{comment.text}</p>
              <div className="flex items-center gap-1 mt-3 text-accent-500">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-xs"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}